import { Slide } from '@/types/slide';
import { gql } from '@apollo/client';

export interface GetSlidesResponse {
    slides: Slide[];
}

export const GET_SLIDES = gql`
    query Slides($where: SlideWhereInput!) {
        slides(where: $where, orderBy: { sort: asc }) {
            id
            data
        }
    }
`;
